import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios, { AxiosError } from "axios";

import { postUsuariosLogin } from "../config/swagger";
import type { LoginResponse } from "../model/loginResponse";

type AuthContextProps = {
	user: LoginResponse | undefined;
	handleLogin: (email: string, password: string) => Promise<true | string>;
	handleLogout: () => void;
};

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export function useAuth() {
	return useContext(AuthContext);
}

type AuthProviderProps = {
	children: ReactNode;
};

export default function AuthProvider({ children }: AuthProviderProps) {
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState<LoginResponse | undefined>();

	useEffect(() => {
		let sessionUser = sessionStorage.getItem("user");
		if (sessionUser) {
			let userJson = JSON.parse(sessionUser);
			setUser(userJson);
		}

		setLoading(false);
	}, []);

	async function handleLogin(email: string, senha: string) {
		try {
			const response = await postUsuariosLogin({ email, senha });
			if (response.Result === 1 && response.Data) {
				sessionStorage.setItem("user", JSON.stringify(response.Data));
				setUser(response.Data);
				return true;
			}
			return response.Message || "Erro ao fazer login";
		} catch (error: any) {
			if (axios.isAxiosError(error)) {
				const axiosError = error as AxiosError<any>;
				if (axiosError.response?.data?.message) {
					return axiosError.response.data.message;
				}
				return axiosError.message;
			}
			return error.message || "Erro desconhecido";
		}
	}

	function handleLogout() {
		setUser(undefined);
		sessionStorage.removeItem("user");
		navigate("/");
	}

	const value = {
		user,
		handleLogin,
		handleLogout,
	};

	if (loading) {
		return <></>;
	}

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
